import React from "react";
import { Typography } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import { useAuth } from "react-oidc-context";

import unauthorizedAccess from "assets/supergasbras/images/unauthorizedAccess.svg";
import Button from "components/atoms/Button";
import { serviceNowUrl } from "config/appConfig";

import * as Styled from "./styles";

const Unauthorized = () => {
  const { t } = useTranslation();
  const auth = useAuth();

  const handleOpenServiceNow = () => {
    window.open(serviceNowUrl, "_blank", "noopener,noreferrer");
  };

  const handleSignOut = () => {
    auth.signoutRedirect();
  };

  return (
    <Styled.Container>
      <Styled.Content>
        <Styled.Illustration
          src={unauthorizedAccess}
          alt={t("unauthorizedTitle")}
        />

        <Typography
          variant="h5"
          component="h1"
          sx={{ fontWeight: 700, mb: 2, color: "text.primary" }}
        >
          {t("unauthorizedTitle")}
        </Typography>

        <Typography
          variant="body1"
          sx={{ mb: 2, color: "text.primary", lineHeight: 1.6 }}
        >
          {t("unauthorizedDescription")}
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "text.primary", lineHeight: 1.6 }}
        >
          <Trans i18nKey="unauthorizedInstruction" />
        </Typography>

        <Styled.Actions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenServiceNow}
          >
            {t("openServiceNow")}
          </Button>
          <Button variant="outlined" color="primary" onClick={handleSignOut}>
            {t("exit")}
          </Button>
        </Styled.Actions>
      </Styled.Content>
    </Styled.Container>
  );
};

export default Unauthorized;
